var map = {
	"./service_1.svg": "0caa",
	"./service_2.svg": "aae0",
	"./service_3.svg": "10ff",
	"./service_4.svg": "f1c5",
	"./service_5.svg": "e8ee",
	"./service_6.svg": "e766",
	"./service_7.svg": "9aa6",
	"./service_8.svg": "82c2",
	"./service_9.svg": "aa14"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f401";